import { Box, Stack, Typography } from "@mui/material";
// config
import colors from "../../../config/colors";
// utils
import {
  decimalFormatter,
  formatNumberKMB,
  formatNumberLakhsCrores,
} from "../../../utils/helpers";
// components
import { CategoryDistribution } from "../../../components/Discover/details";
import Demographics from "../../../components/Discover/details/Demographics";

const OverviewTab = ({ details }) => {
  const overviewData = [
    {
      title: "Followers:",
      children: (
        <Typography fontSize={24} fontWeight={600}>
          {formatNumberKMB(details?.insta_followers)}
        </Typography>
      ),
      footer: "last 3 months",
    },
    {
      title: "Account Engaged:",
      children: (
        <Stack flexDirection={"row"} gap={1} alignItems="baseline">
          <Typography fontSize={24} fontWeight={600}>
            {formatNumberKMB(details?.total_accounts_engaged)}
          </Typography>
        </Stack>
      ),
      footer: "last 3 months",
    },

    {
      title: "Accounts Reached:",
      children: (
        <Typography fontSize={24} fontWeight={600}>
          {formatNumberKMB(details?.total_reach)}
        </Typography>
      ),
      footer: "last 3 months",
    },
    {
      title: "Average Views:",
      children: (
        <Typography fontSize={24} fontWeight={600}>
          {formatNumberKMB(details?.overall_median_views)}
        </Typography>
      ),
      footer: "last 3 months",
    },
    {
      title: "Interaction Rate:",
      children: (
        <Typography fontSize={24} fontWeight={600}>
          {decimalFormatter(details?.overall_engagement_rate_percentage, "%")}
        </Typography>
      ),
      footer: "last 3 months",
    },
    // TODO: Add hook rate
    // {
    //   title: "Hook Rate:",
    //   children: (
    //     <Typography fontSize={24} fontWeight={600}>
    //       {decimalFormatter(details?.overall_hook_rate_percentage, "%")}
    //     </Typography>
    //   ),
    //   footer: "last 3 months",
    // },
  ];

  const salesData = [
    {
      title: "Clicks:",
      children: (
        <Typography fontSize={24} fontWeight={500} lineHeight="32px">
          {formatNumberKMB(details?.total_clicks)}
        </Typography>
      ),
      footer: "last 3 months",
    },

    {
      title: "Conversion Rate:",
      children: (
        <Typography fontSize={24} fontWeight={500} lineHeight="32px">
          {details?.overall_conversion_percentage}%
        </Typography>
      ),
      footer: "last 3 months",
    },
    {
      title: "Sales:",
      children: (
        <Typography fontSize={24} fontWeight={500} lineHeight="32px">
          ₹ {formatNumberLakhsCrores(details?.total_sales)}
        </Typography>
      ),
    },
    {
      title: "AOV:",
      children: (
        <Typography fontSize={24} fontWeight={500} lineHeight="32px">
          ₹ {formatNumberLakhsCrores(details?.aov)}
        </Typography>
      ),
    },
  ];

  return (
    <Stack flex={1} gap={2}>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "8px",
          width: "100%",
        }}
      >
        <Stack
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
          }}
        >
          <Typography fontSize={12} fontWeight={500} lineHeight="20px">
            Social:
          </Typography>
          {/* <Typography
            fontSize={12}
            fontWeight={400}
            lineHeight="20px"
            sx={{ opacity: 0.5 }}
          >
            for last 30 days
          </Typography> */}
        </Stack>
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: "repeat(3, 1fr)",
            gap: "8px",
          }}
        >
          {overviewData?.map((item, index) => (
            <Box
              key={index}
              sx={{
                border: `1px solid ${colors.gray100}`,
                borderRadius: "4px",
                p: "8px 12px",
                display: "flex",
                flexDirection: "column",
                gap: "4px",
                backgroundColor: colors.white,
              }}
            >
              <Typography fontSize={12}>{item?.title}</Typography>
              {item?.children}
              {/* <Typography fontSize={12} color={colors.gray200}>
              {item?.footer}
            </Typography> */}
            </Box>
          ))}
        </Box>
      </Box>
      <Demographics details={details} />
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "8px",
          width: "100%",
          marginTop: "16px",
        }}
      >
        <Stack
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
          }}
        >
          <Typography fontSize={12} fontWeight={500} lineHeight="20px">
            Sales:
          </Typography>
          <Typography
            fontSize={12}
            fontWeight={400}
            lineHeight="20px"
            sx={{ opacity: 0.5 }}
          >
            for last 90 days
          </Typography>
        </Stack>
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: `repeat(${salesData?.length || 1}, 1fr)`,
            gap: "8px",
          }}
        >
          {salesData?.map((item, index) => (
            <Box
              key={index}
              sx={{
                border: `1px solid ${colors.gray100}`,
                borderRadius: "4px",
                p: "8px 12px",
                display: "flex",
                flexDirection: "column",
                gap: "8px",
                backgroundColor: colors.white,
                minWidth: 0,
              }}
            >
              <Typography fontSize={12} lineHeight="20px">
                {item?.title}
              </Typography>
              {item?.children}
            </Box>
          ))}
        </Box>
      </Box>
      <CategoryDistribution distribution={details?.product_categories || []} />
    </Stack>
  );
};

export default OverviewTab;
